import { Node, mergeAttributes } from '@tiptap/core';

const ContentItem = Node.create({
  name: 'contentItem',
  group: 'inline',
  inline: true,
  content: 'inline*',

  addAttributes() {
    return {
      class: { default: 'content-item' },
      'data-pronunciation': { default: null },
    };
  },

  parseHTML() {
    return [{ tag: 'span.content-item' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes(HTMLAttributes), 0];
  },
});

export default ContentItem;
